<template>
  <StudyParticipants :isTestPortal="true"></StudyParticipants>
</template>
<script>
import StudyParticipants from "./study-participants.vue";

export default {
  name: "test-portal-study-participanta",
  components: {
    StudyParticipants
  }
};
</script>
